import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ApiBusinessService } from 'src/app/services/api-business.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserService } from 'src/app/services/user.service';
import { CiudadesService } from '../../../../../services/ciudades.service';

@Component({
  selector: 'app-update-business',
  templateUrl: './update-business.component.html',
  styleUrls: ['./update-business.component.scss']
})
export class UpdateBusinessComponent {

  changeForm: FormGroup;
  valueChange: any;
  valueInit: any;
  nameValue: any;
  idBusiness!: any;

  editorConfigBusiness: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '400px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Condiciones generales de uso y políticas de compra de la organización.',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Satoshi-Regular',
    defaultFontSize: '',
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'insertUnorderedList',
        'insertOrderedList',
        'heading',
        'fontName'
      ],
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };

  cities: any[] = [];
  states: any[] = [];
  countries: any[] = [];

  constructor(private formBuilder: FormBuilder, private businessService: ApiBusinessService,
    private auth: AuthenticationService, private dialogRef: MatDialogRef<UpdateBusinessComponent>, private ciudadesService: CiudadesService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data) { }

  // Función para comparar valores en los mat-select (maneja comparación entre string y number)
  compareById(o1: any, o2: any): boolean {
    return o1 && o2 ? o1 == o2 : o1 === o2;
  }

  ngOnInit(): void {
    this.idBusiness = this.data['id'];
    this.nameValue = this.data['name'];
    this.valueChange = this.data['valueChange'];
    this.valueInit = this.data['value'];
    this.changeForm = this.formBuilder.group({
      name: [this.valueInit.name, Validators.required],
      address: [this.valueInit.address],
      city: [this.valueInit.city?.name || this.valueInit.city],
      postal_code: [this.valueInit.postal_code],
      id_country: [this.valueInit.country?.id],
      id_state: [this.valueInit.state?.id],
      general_conditions: [this.valueInit.general_conditions || ""],
      description: [this.data['description']],
      slug: [this.valueInit.slug, this.valueChange === 'slug' ? Validators.required : null],
      // Comisión de taquilla: solo la toca el superadmin desde el listado de
      // empresas, nunca el propio organizador desde su configuración.
      ticket_office_fee: [
        // A número, que la API lo serializa con los cuatro decimales de la
        // columna ("0.3500") y en un campo de edición esos ceros sobran.
        Number(this.valueInit.ticket_office_fee ?? 0),
        this.valueChange === 'ticket_office_fee' ? [Validators.required, Validators.min(0)] : null,
      ],
    });

    if(this.valueChange == 'address') {
    this.ciudadesService.getCountries().subscribe({
      next: (data) => {
        this.countries = data.data;
        // Actualizar el valor después de cargar los países para que se muestre correctamente
        if (this.valueInit.country?.id) {
          this.changeForm.patchValue({ id_country: this.valueInit.country.id });
        }
      }
    });

    this.ciudadesService.getStates().subscribe({
      next: (data) => {
        this.states = data.data;
        // Actualizar el valor después de cargar los estados para que se muestre correctamente
        if (this.valueInit.state?.id) {
          this.changeForm.patchValue({ id_state: this.valueInit.state.id });
        }
      }
    });
    }
  }

  get value() { return this.changeForm.get(this.valueChange); }

  changeBusiness() {
    if (!this.changeForm.valid) {
      this.changeForm.markAllAsTouched();
      return;
    }
    this.submitBusinessChange();
  }

  private submitBusinessChange() {
    let payload: any = null;
    switch (this.valueChange) {
      case 'nameCitylok':
        payload = { name: this.changeForm.value.name };
        break;
      case 'address':
        payload = {
          address: this.changeForm.value.address,
          city: this.changeForm.value.city,
          postal_code: this.changeForm.value.postal_code,
          id_country: this.changeForm.value.id_country,
          id_state: this.changeForm.value.id_state,
        };
        break;
      case 'general_conditions':
        payload = { general_conditions: this.changeForm.value.general_conditions };
        break;
      case 'description':
        if (this.changeForm.value.description?.length > 510) {
          this.dialogRef.close({
            status: 'error',
            msg: 'Lo sentimos, no puedes superar los 500 caracteres permitidos.',
          });
          return;
        }
        payload = { description: this.changeForm.value.description };
        break;
      case 'slug':
        payload = { slug: this.changeForm.value.slug.replace(/\s+/g, '') };
        break;
      case 'ticket_office_fee':
        payload = { ticket_office_fee: this.changeForm.value.ticket_office_fee };
        break;
    }

    this.businessService.setBusinessById(this.idBusiness, payload).subscribe({
      next: (data) => {
        this.dialogRef.close({ status: 'changed', value: data.data });
      },
      error: (err) => {
        const backendMsg =
          err?.error?.errors?.slug?.[0] ||
          err?.error?.message ||
          'La URL personalizada ya está en uso';

        this.dialogRef.close({ status: 'error', msg: backendMsg });
      },
    });
  }
}
